export default class Fornecedor {
    constructor(_id, dtInclusao, produto, CNPJ, xNome, xFant, IE, CRT, qtd, vlrMin, vlrMax, dtPrimeiraCompra, dtUltimaCompra, qntServico, CPF, customValues, enderEmit, nfes, conta) {

        // this.emissao = ,
        // this.emissao = emissao.substring(0, emissao.indexOf("T")).split('-').reverse().join('/'),
        this.xNome = xNome,
            CNPJ != undefined && CPF != undefined ? this.CNPJ = `${CNPJ} - ${CPF}` : CNPJ != undefined && CPF == undefined ? this.CNPJ = CNPJ : this.CNPJ = CPF,
            this.trabFiliado = qtd > 0 && qntServico > 0 ? 'nfe_nfse' : qtd > 0 && qntServico == 0 ? 'nfe' : 'nfse',
            this.dtPrimeiraCompra = new Date(dtPrimeiraCompra),
            this.dtUltimaCompra = new Date(dtUltimaCompra),
            this.vlrMin = vlrMin,
            this.vlrMax = vlrMax,
            this.qtd = qtd,
            this.qntServico = qntServico,
            this.dtInclusao = new Date(dtInclusao),
            this.xFant = xFant,
            this.IE = IE,
            this.CRT = CRT,
            this._id = _id,
            this.enderEmit = enderEmit,
            this.conta = conta,
            this.nfes = nfes,
            this.customValues = customValues

    }
}





// WEBPACK FOOTER //
// ./src/domain/fornecedores/Fornecedores.js